module.exports = __webpack_public_path__ + "static/img/5.c2a20df.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue12/03/5.jpeg
// module id = Q1vt
// module chunks = 7